import React from "react";
import PropTypes from "prop-types";

import SavedCardForm from "./SavedCardForm";
import EmptyForm from "./EmptyForm";

const CardForm = ({ showSavedCard, form, response, handleFormChange }) => {
    return (
        <div data-testid="checkout-card-form">
            {showSavedCard ? (
                <SavedCardForm
                    form={form}
                    response={response}
                    handleFormChange={handleFormChange}
                />
            ) : (
                <EmptyForm form={form} handleFormChange={handleFormChange} />
            )}
        </div>
    );
};

CardForm.propTypes = {
    showSavedCard: PropTypes.bool.isRequired,
    response: PropTypes.object,
    form: PropTypes.object,
    handleFormChange: PropTypes.func.isRequired
};

export default CardForm;
